export const ICONS_DEFAULT_ATTRIBUTES = {
  pr: 1,
  fontSize: 'lg',
  pt: 1,
};
